import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const EscBackHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        if (location.pathname !== "/") {
          navigate(-1); // Go back one step in history
        }
        // If on home ("/"), do nothing
      }
    };

    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [navigate, location]);

  return null; // Listener only
};

export default EscBackHandler;
